/**
 * jump-to-step-modal.component.ts
 * Copyright (c) 2016-2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";

import { AlgorithmStep } from "../algorithms/structure";
import { ControlGroup } from "../common/data/control-group";

export class GroupListContext extends BSModalContext
{
  public groups : ControlGroup[];
}

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      Jump to Step...
    </h4>
  </div>

  <div class="modal-body">
    <p>Select a step to jump to:</p>
    <select
      [formControl]="selected"
      class="form-control"
      (change)="jump()">
      <option
        *ngFor="let step of steps"
        [ngValue]="step.id">
        {{step.displayName || step.name}}
      </option>
    </select>
  </div>
  `,
  styles: []
})
export class JumpToStepModalComponent
  implements ModalComponent<GroupListContext>
{
  public steps : AlgorithmStep[] = [];

  public selected : FormControl = new FormControl();

  constructor (public dialog : DialogRef<GroupListContext>)
  {
    dialog.context.groups.forEach((group : ControlGroup) => {
      this.steps = this.steps.concat(group.steps as any[]);
    });
    this.steps.sort((a : AlgorithmStep, b : AlgorithmStep) =>
      ((a.displayName || a.name || "").localeCompare(
        b.displayName || b.name)));
  }

  public jump () : void
  {
    console.warn("JUMP", this.selected.value);
    if (this.selected.value)
    {
      this.dialog.close(this.selected.value);
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/jump-to-step-modal.component.ts